import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import { AxiosPromise } from 'axios';
const rootPath = 'bopmodels';

class BopModelService {
    public getTableUrl(lang:string): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}${buildQuery({lang})}`;
    }
    public async getBopModels(lang:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang})}`);
    }
    public async getBopModel(bopModelId:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/${bopModelId}${buildQuery({lang})}`);
    }
    public async getDeployedBopModelsOnSite(siteId:string,entrepriseId:string): Promise<any> {
        return apiClient.get(`${rootPath}/deployed${buildQuery({siteId,entrepriseId})}`);
    }
      public async getDeployedBySite(siteId:string): Promise<any> {
        return apiClient.get(`${rootPath}/bySite${buildQuery({siteId})}`);
    }
    public async CanHaveExceptions(id:string): Promise<any> {
        return apiClient.get(`${rootPath}/${id}/canHaveExceptions`);
    }
    public getTranslationsUrl(params: any): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}/GetAllTranslations${buildQuery({bopModelKey: params.bopModelKey})}`;
    }
    public async listByEntrepriseAndTypeTravaux(entrepriseId:any,typetravauxId:any,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/entreprise/${entrepriseId}/typetravaux/${typetravauxId}${buildQuery({lang})}`);
    }

    public save(data: any,lang:string): AxiosPromise {
        return apiClient.put(`${rootPath}/${data.site.id}${buildQuery({lang})}`, data);
    }

    public addTranslations(data: any,lang:string): AxiosPromise {
        return apiClient.put(`${rootPath}/addTranslations/${data.id}`, data);
    }

    public updateNonNullProperties(data: any,lang:string): AxiosPromise {
        return apiClient.patch(`${rootPath}/${data.id}${buildQuery({lang})}`, data);
    }
}

export default new BopModelService();